import NeedHelp from 'core/components/NeedHelp';
import PageBanner from 'core/components/PageBanner/index';
import ServiceDescription from 'core/components/ServiceDescription';
import TableSkeleton from 'core/components/skeleton';
import { Table, TableWithIntervalPrices, TableWithIntervalQuantities } from 'core/components/Table';
import Images from 'core/data/constants/Images';
import { IroningModel } from 'features/ironing/data/models/IroningModel';
import { AbstractIroningRemoteDataSource } from 'features/ironing/data/remote/Abstract_ironing_remote_data_source';
import { IroningRemoteDataSource } from 'features/ironing/data/remote/Ironing_remote_data_source';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';
import { SewingModel } from 'features/sewing/data/models/SewingModel';
import { IroningPackageModel } from 'features/ironing/data/models/IroningPackageModel';
import MotionDiv from 'core/components/Motion';

export const Ironing = () => {
  const { t } = useTranslation();
  const [assortedClothes, setAssortedClothes] = useState<IroningPackageModel[]>([]);
  const [assortedClothesWithoutClothes, setAssortedClothesWithoutClothes] = useState<IroningPackageModel[]>([]);
  const [ironByPiece, setIronByPiece] = useState<SewingModel[]>([]);
  const [washingAndIroningTshisrtPackageContract, setWashingAndIroningTshisrtPackageContract] = useState<IroningModel[]>([]);
  const [washingAndIroningByPiece, setWashingAndIroningByPiece] = useState<IroningModel[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const ironingRemoteDataSource: AbstractIroningRemoteDataSource = new IroningRemoteDataSource();
        const [res1, res2, res3, res4, res5] = await Promise.all([
          ironingRemoteDataSource.getWashingAndIroningTshisrtPackageData(),
          ironingRemoteDataSource.getWashingAndIroningByPieceData(),
          ironingRemoteDataSource.getAssortedClothesData(),
          ironingRemoteDataSource.getAssortedClothesWithoutShirtsData(),
          ironingRemoteDataSource.getIronByPieceData(),
        ]);

        setWashingAndIroningTshisrtPackageContract(res1.success ? res1.data : []);
        setWashingAndIroningByPiece(res2.success ? res2.data : []);
        setAssortedClothes(res3.success ? res3.data : []);
        setAssortedClothesWithoutClothes(res4.success ? res4.data : []);
        setIronByPiece(res5.success ? res5.data : []);
      } catch (error) {
        // console.error("API error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mainIroning pageBody">
      <PageBanner imagePath={Images.IroningBannerImage} title={t('ironing_title')} />
      <div className="content" >
        <MotionDiv className="contentDescription" viewport={{ amount: 0 }} initial={{ opacity: 0, x: -40 }}>
          <ServiceDescription title="ironing_title" description="ironing_description" />
          <NeedHelp />
        </MotionDiv>

        <div className="table">
          <div id="washingIroningDryClean">
            <MotionDiv viewport={{ once: false, amount: 0 }}>
              <h1>{t('washing_ironing_dry_clean')}</h1>
              <h2>{t('washing_ironing_dry_clean_by_piece')}</h2>
              {washingAndIroningByPiece.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={washingAndIroningByPiece} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

          </div>
          <div id="ironingPackagesTableSection">
            <MotionDiv>
              <h1>{t("ironing_package")}</h1>
              <h2>{t('assorted_clothes')}</h2>
              {assortedClothes.length ? (
                <TableWithIntervalQuantities columnNames={[t('default_article'), t('default_price')]} data={assortedClothes} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h2>{t('assorted_clothes_without_shirts')}</h2>
              {assortedClothesWithoutClothes.length ? (
                <TableWithIntervalQuantities columnNames={[t('default_article'), t('default_price')]} data={assortedClothesWithoutClothes} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h2>{t('default_washing_and_ironing_tshirt_package')}</h2>
              {washingAndIroningTshisrtPackageContract.length ? (
                <Table columnNames={[t('default_article'), t('default_price')]} data={washingAndIroningTshisrtPackageContract} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
              <label>{t('default_washing_and_ironing_tshirt_package_label')}</label>
            </MotionDiv>
          </div>
          <div id="ironingTableSection">
            <h1> {t('ironing')}</h1>

            <MotionDiv viewport={{ once: true, amount: 0.05 }}>
              <h2>{t('default_iron_by_piece')}</h2>
              {ironByPiece.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={ironByPiece} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>
          </div>
        </div>
      </div>
      <div className='footerSeperator'>
      </div>
    </div >
  );
};

export default Ironing;
